// API Endpoints for Organizations management
import { rivermeadowApi } from './api';

export const organizations = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        changeOrganization: builder.mutation({
            query: ({ userId, orgId }) => ({
                url: `/users/${userId}/organization/${orgId}/switch`,
                method: 'PUT',
            }),
            invalidatesTags: ['ORGANIZATION'],
        }),
        getOrganization: builder.query({
            query: ({ orgId }) => ({
                url: `/organizations/${orgId}`,
                method: 'GET',
            }),
            providesTags: ['ORGANIZATION'],
        }),
    }),
});

export const { useChangeOrganizationMutation, useGetOrganizationQuery, useLazyGetOrganizationQuery } = organizations;
